export class BasicLanguageVersion {
    //TODO @HTML5 HTML-961 HTML-925 who / when / how sets this?
    public static BUILD_NUMBER: string = "4";
    public static VERSION: string = "1";
    public static DATE: string = "201006221330";
}